import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advisory-board',
  templateUrl: './advisory-board.component.html',
  styleUrls: ['./advisory-board.component.scss']
})
export class AdvisoryBoardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
